import React from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { MsalProvider } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { AUTH_CONFIG, AUTH_SCOPES } from './authConfig';
import { AuthAccessProvider } from './AuthAccessProvider';
import { getMsalInstance } from './msalClient';

function AuthProviderWithNavigate({ children }) {
  const navigate = useNavigate();

  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || window.location.pathname || '/', { replace: true });
  };

  if (AUTH_CONFIG.isEntra) {
    return (
      <MsalProvider instance={getMsalInstance()}>
        <AuthAccessProvider>
          {children}
        </AuthAccessProvider>
      </MsalProvider>
    );
  }

  return (
    <Auth0Provider
      domain={AUTH_CONFIG.auth0.domain}
      clientId={AUTH_CONFIG.auth0.clientId}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/`,
        audience: AUTH_CONFIG.audience,
        scope: AUTH_SCOPES
      }}
      cacheLocation="localstorage"
      onRedirectCallback={onRedirectCallback}
    >
      <AuthAccessProvider>
        {children}
      </AuthAccessProvider>
    </Auth0Provider>
  );
}

export default AuthProviderWithNavigate;
